import React from 'react';
import { Container, LoadingSpinner, Sheet, IconButton, Button, ArrowLeftIcon } from '@paypalcorp/pp-react';
import { parseMessages } from '../../utilityHelper';
import * as FPT from '../../utility/fpt';
import Success from '../../common/components/Success';
import Consent from './Consent';
import EnrollmentForm from './EnrollmentForm';
import { get } from 'lodash';
import { launchRedirect } from '../../lib/validate';
import { show, hide } from '../../common/domUtils';
import { postMulitPartData } from '../../common/serviceRequest';
import withTheme from "../../common/withTheme";

const propertyInfo = parseMessages('directmodel/home');
let charityInfo = {};

try {
    charityInfo = JSON.parse(document.getElementById('data-charity-info') && document.getElementById('data-charity-info').innerHTML || '{}');
} catch (e) {
    console.warn('Error while parsing data', e);
}

class Enroll extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            enrollStatus: document.getElementById('data-enroll-status') && document.getElementById('data-enroll-status').innerHTML || '',
            update: document.getElementById('data-intent') && document.getElementById('data-intent').innerHTML || '',
            fileUrl: charityInfo.logo,
            fileError: '',
            errors: [],
            serviceError: false,
            charityInfo: charityInfo,
            inputMissionAreaSelect: get(charityInfo, 'missionAreaList[0].id', '').toString(),
            inputMissionAreaSecondSelect: get(charityInfo, 'missionAreaList[1].id', '').toString(),
            inputMissionAreaThirdSelect: get(charityInfo, 'missionAreaList[2].id', '').toString(),
        };
    }

    updateFileError = (fileError) => {
        document.getElementById('logoImage').focus();
        this.setState({
            fileError: fileError
        });
    }

    updateFileInfo = (fileUrl) => {
        document.getElementById('logoImage').focus();
        this.setState({
            fileUrl: fileUrl,
        });
    }

    validateEnrollFrom = (data) => {
        let errors = [];
        let valid = true;
        let fileError = '';
        for (let key in data) {
            if (['desc', 'cta', 'missionArea', 'keywords'].includes(key) && !data[key]) {
                errors.push(key);
                valid = false;
            }
            if (key === 'fileupload' && !this.state.fileUrl) {
                errors.push(key);
                fileError = propertyInfo.directmodel.enroll.uploadlogo.error;
                valid = false;
            }
        }
        errors.length && document.getElementById(errors[0]).focus();
        this.setState({ errors: errors, fileError: fileError });
        return valid;
    }

    enrollSubmit = async (event, missionAreaData = '') => {
        event.preventDefault();
        show('.loadingspinner', 'flex');
        const formFields = {
            description: document.getElementById('desc').value,
            slogan: document.getElementById('cta').value,
            fileupload: document.getElementById('fileupload').files ? document.getElementById('fileupload').files[0] : '',
            missionArea: missionAreaData.inputMissionAreaSelect || this.state.inputMissionAreaSelect,
            missionAreaSecond: missionAreaData.inputMissionAreaSecondSelect || this.state.inputMissionAreaSecondSelect,
            missionAreaThird: missionAreaData.inputMissionAreaThirdSelect || this.state.inputMissionAreaThirdSelect,
            keywords: document.getElementById('keywords').value,
            update: this.state.update ? true : false,
            _csrf: document.getElementsByTagName('body')[0].getAttribute('data-csrf'),
            npid: charityInfo.nonProfitId,

        };
        const valid = this.validateEnrollFrom(formFields, this);
        FPT.trackButtonClickWithData('enrollSubmitBtn', { pageParams: { isValidInput: valid } });
        if (!valid) {
            hide('.loadingspinner');
            return;
        }
        try {
            let formData = new FormData();
            for (let key in formFields) {
                formData.append(key, formFields[key]);
            }
            let response = await postMulitPartData('/givingfund/enroll/submit', 'POST', formData);
            if (response.submitResult) {
                FPT.trackPageWithData(charityInfo.retireConsentPage ? 'main:givingfund:enroll:showSuccess' : 'main:givingfund:enroll:showconsent', { enrollStatus: response.enrollStatus });
                if (this.state.update) {
                    launchRedirect('/businessmanage/account/aboutCharity');
                } else {
                    this.updateEnrollStatus(charityInfo.retireConsentPage ? 'completed' : 'showConsent');
                }
            } else if (response.case == 'restrictAccount') {
                launchRedirect('/givingfund/restrictaccount');
            } else {
                if (response?.errorObj?.error === 'MEDIASERV_ERROR') {
                    this.setState({ fileError: propertyInfo.directmodel.enroll.uploadlogo?.[response?.errorObj?.statusCode === 400 ? 'mediaserv-400' : 'mediaserv-500'] });
                } else {
                    throw "Service Error";
                }
            }
        } catch (error) {
            FPT.trackPageWithData('main:givingfund:enroll:error', { enrollStatus: 'confirmed' });
            this.setState({ serviceError: true });
            window.scrollTo(0, 0);
        }
        hide('.loadingspinner');
    }

    updateEnrollStatus = (enrollStatus) => {
        this.setState({
            enrollStatus: enrollStatus
        });
    }

    onCloseSheet = () => {
        FPT.trackButtonClick('closeProfileUpdate');
        show('.loadingspinner', 'flex');
        launchRedirect('/businessmanage/account/aboutCharity');
    }

    componentDidMount() {
        hide('.loadingspinner');
        FPT.trackPageWithData('main:givingfund:enroll', { enrollStatus: this.state.enrollStatus, intent: this.state.update ? 'update' : '' });
    }

    missionAreaSelectHandler = (missionAreaSelectVal) => {
        this.setState({ inputMissionAreaSelect: missionAreaSelectVal })
    }
    missionAreaSecondSelectHandler = (missionAreaSecondSelectVal) => {
        this.setState({ inputMissionAreaSecondSelect: missionAreaSecondSelectVal })
    }
    missionAreaThirdSelectHandler = (missionAreaThirdSelectVal) => {
        this.setState({ inputMissionAreaThirdSelect: missionAreaThirdSelectVal })
    }

    render() {

        const enrollStatus = this.state.update ? "update" : this.state.enrollStatus;
        const enrollmentFormFields = {
            updateFileError: this.updateFileError,
            updateFileInfo: this.updateFileInfo,
            fileError: this.state.fileError,
            fileUrl: this.state.fileUrl,
            errors: this.state.errors,
            serviceError: this.state.serviceError,
            charityInfo: this.state.charityInfo,
        };

        return (
            <div id="directModelWrapper">
                <div className="loadingspinner">
                    <LoadingSpinner size="xl" screenReaderText={propertyInfo.directmodel.loading} />
                </div>
                <Container className="container">
                    {enrollStatus == 'update' &&
                        <Sheet
                            title={get(propertyInfo, 'directmodel.enroll.update.header')}
                            hideTitle={true}
                            showLogo={true}
                            className="updateProfile"
                            isOpen={true}
                            action={<IconButton onClick={this.onCloseSheet} svgIconComponent={ArrowLeftIcon} buttonType="tertiary" />}
                            footerAlign="center"
                            footerContents={
                                <Button onClick={this.enrollSubmit} id="enrollSubmit">
                                    {get(propertyInfo, 'directmodel.enroll.update.button')}
                                </Button>
                            }
                            footerClassName="updateProfileFooter"
                            onClose={this.onCloseSheet}>
                            <EnrollmentForm missionAreaSelectHandler={this.missionAreaSelectHandler} missionAreaSecondSelectHandler={this.missionAreaSecondSelectHandler} missionAreaThirdSelectHandler={this.missionAreaThirdSelectHandler} inputMissionAreaSelect={this.state.inputMissionAreaSelect} inputMissionAreaSecondSelect={this.state.inputMissionAreaSecondSelect} inputMissionAreaThirdSelect={this.state.inputMissionAreaThirdSelect} enrollmentFormFields={{ ...enrollmentFormFields }} />
                        </Sheet>}
                    {enrollStatus === 'completed' &&
                        <Success
                            header={get(propertyInfo, 'directmodel.success.header')}
                            bodyContent={get(propertyInfo, 'directmodel.success.info')}
                            buttonInfo={{ url: '/', text: get(propertyInfo, 'directmodel.success.continue'), as: "a" }}
                            successImgText={get(propertyInfo, 'directmodel.success.imgtext')} />}
                    {(enrollStatus === 'showConsent') &&
                        <Consent updateEnrollStatus={this.updateEnrollStatus} propertyInfo={propertyInfo} />}
                    {(enrollStatus === 'confirmed') &&
                        <Container className="outerContainer">
                            <EnrollmentForm
                                missionAreaSelectHandler={this.missionAreaSelectHandler}
                                missionAreaSecondSelectHandler={this.missionAreaSecondSelectHandler}
                                missionAreaThirdSelectHandler={this.missionAreaThirdSelectHandler}
                                enrollSubmit={this.enrollSubmit}
                                inputMissionAreaSelect={this.state.inputMissionAreaSelect}
                                inputMissionAreaSecondSelect={this.state.inputMissionAreaSecondSelect}
                                inputMissionAreaThirdSelect={this.state.inputMissionAreaThirdSelect}
                                enrollmentFormFields={{ ...enrollmentFormFields }} />
                        </Container>}
                </Container>
            </div>
        );

    }
}
export default withTheme(Enroll);